/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import openOtherApp$1 from './cnStation/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var extendOpenOtherApp = extend({
    web: {
        windvane: {
            cnStation: openOtherApp$1,
        },
    },
});
/**
 * 打开其他应用。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * 目前支持：【驿站掌柜App】
 * @param {!string | OpenOtherAppIOptions} url scheme协议
 * @returns {Promise<unknown>} promise调用结果
 *
 * @example
 * import { openOtherApp } from '@alife/cn-uni-api';
 *
 * openOtherApp('dingtalk://dingtalkclient/page/myProfile').then(() => {
 *   console.log('success');
 * }).catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var openOtherApp = function (url) {
    if (url && typeof url === 'object') {
        return extendOpenOtherApp(url);
    }
    return extendOpenOtherApp({ url: url });
};

export { openOtherApp };
